import React, { Suspense } from 'react';
import { Redirect } from 'react-router-dom';

import Box from '@material-ui/core/Box';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

import {
  AUClientLogin,
  AUProductTrailSuggestion,
  Envs,
  PRODUCT_IDS,
  browserHistory,
} from '@assertiva/assertiva-ui';

import SignaturePage from '@src/pages/Signature';
import PasswordIcon from '@src/components/Icons/PasswordIcon';
import { sendAnalytics } from '@utils/analytics';
import { EVENTS } from './constants/analytics';

const Container = ({ children }) => {
  return (
    <Box p={5} maxWidth="1188px" margin="auto">
      {children}
    </Box>
  );
};

const getRouter = () => {
  return [
    {
      id: 0,
      exact: true,
      path: '/',
      redirect: '/assinaturas',
      isPrivate: false,
      component: (props) => (
        <Suspense fallback={<div>Loading...</div>}>
          <AUClientLogin {...props} />
        </Suspense>
      ),
    },
    {
      id: 1,
      path: '/inicio',
      isPrivate: true,
      exact: true,
      component: () => <Redirect to="/assinaturas" />,
    },
    {
      id: 2,
      productId: PRODUCT_IDS.ASSINATURAS,
      path: '/',
      label: 'Assinaturas',
      isPrivate: true,
      exact: true,
      showInMenu: true,
      icon: <PasswordIcon viewBox="0 0 20 20" />,
      action: () => {
        sendAnalytics(EVENTS.CLICK_SIGNATURE);
        browserHistory.push('/assinaturas');
      },
      nested: [
        {
          id: 3,
          exact: true,
          path: '/assinaturas',
          label: 'Assinaturas',
          showInMenu: false,
          isPrivate: true,
          component: () => {
            return (
              <Container>
                <AUProductTrailSuggestion />
                <SignaturePage />
              </Container>
            );
          },
        },
        {
          id: 4,
          showInMenu: true,
          action: () => {
            window.location.href = `${
              Envs().PAINEL_URL
            }/gestao-da-conta/relatorios/assinaturas`;
          },
          label: 'Relatórios',
          icon: <DescriptionOutlinedIcon />,
          exact: true,
          isPrivate: true,
        },
      ],
    },
  ];
};

export default getRouter;
